<!-- app-routing.module.ts Components should have Breadcrumbs at the top -->
<nav class="breadcrumbs">
  <ul class="pagination">
    <li class="dark"><a routerLink="/">{{ dashboardService.client.name }}</a></li>
    <li class="disabled"><a routerLink="/seo">SEO</a></li>
  </ul>
  <a routerLink="/seo/settings"><i class="large glyphicon glyphicon-cog"></i></a>
  <br />
  <a class="underline reverse" *ngIf="dashboardService.website" target="_blank" href="{{ '//' + dashboardService.website.domain }}">
    {{ dashboardService.website.domain }}
  </a>
</nav>

<br />

<!-- SEO Chart -->
<div class="container-fluid">
  <div class="row">
    <div class="col-xs-8">
      <matrix-tools-chart [title]="'Google Rankings for Local Keywords'" [chartData]="seoChartData">
        Loading Chart...
      </matrix-tools-chart>
    </div>
  </div>
</div>

<!--//jeb if NO keywords are configured click goes to SEO SETTINGS -->
<div *ngIf="dashboardService.website" class="container-fluid text-center">
  <div>
    <h2>Target Keywords</h2>
    <table>
      <thead>
        <tr>
          <th>Keyword</th>
          <th>Rank</th>
          <th>Previous</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let keywordMetric of dashboardService.website.targetedLastMonthKeywords">
          <td>
            <a class="bold" href="https://www.google.com/search?q={{ keywordMetric.keys.join(', ') }}" target="_blank"
              title="Perform a google search for {{ keywordMetric.keys.join(', ') }}">
              {{ keywordMetric.keys.join(', ') }}
            </a>
          </td>
          <td>
            {{ keywordMetric.position?.toFixed(1) }}
          </td>
          <td><!--//jeb prev doesn't work anymore was hacked in the etag - move to chart anyways? -->
            {{ keywordMetric.previousPosition?.toFixed(1) }}
          </td>
        </tr>
      </tbody>
      <caption align="bottom" class="italic">
        * Data is pulled directly from Google.<br />
        * Rank is the average position on Google for the last 30 days.<br />
        * Previous is the average position on Google for the previous 30 days.
      </caption>
    </table>
  </div>
  <br />
  <div>
    <h2><span class="italic">Local</span> Target Keywords</h2>
    <table>
      <thead>
        <tr>
          <th>Keyword</th>
          <th>Rank</th>
          <th>Previous</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let keyword of dashboardService.website.keywords">
          <td>
            <a class="bold" href="https://www.google.com/search?q={{ keyword }}" target="_blank"
              title="Perform a google search for {{ keyword }}">
              {{ keyword }}
            </a>
          </td>
          <td class="bold">
            1
          </td>
          <td>
            ?
          </td>
        </tr>
      </tbody>
      <caption align="bottom" class="italic">
        * Data is pulled directly from Google.<br />
        * Rank is the average position on Google for the last 30 days.<br />
        * Previous is the average position on Google for the previous 30 days.
      </caption>
    </table>
  </div>
  <br />
  <div>
    <h2>Top Keywords by Clicks</h2>
    <table>
      <thead>
        <tr>
          <th>Keyword</th>
          <th>Clicks</th>
          <th>Views</th>
          <th>Click Rate</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let keywordMetric of dashboardService.website.topTenAllTimeKeywords">
          <td>
            <a class="bold" href="https://www.google.com/search?q={{ keywordMetric.keys.join(', ') }}" target="_blank"
              title="Perform a google search for {{ keywordMetric.keys.join(', ') }}">
              {{ keywordMetric.keys.join(', ') }}
            </a>
          </td>
          <td class="bold">
            {{ keywordMetric.clicks }}
          </td>
          <td>
            {{ keywordMetric.impressions }}
          </td>
          <td>
            {{ (keywordMetric.ctr * 100).toFixed(1) + '%' }}
          </td>
        </tr>
      </tbody>
      <caption align="bottom" class="italic">
        * Data is pulled directly from Google.
      </caption>
    </table>
  </div>
</div>

<br />
<br />

<!-- //jeb need less tables here, and more charts! etc MAKE THEM LOOK LIKE BLACK TILE BUTTONS-->
<div *ngIf="dashboardService.website">
  <fieldset>
    <legend>
      Google Keywords ~ Targeted Local Keywords ~ Last Month
    </legend>
    <div class="container-fluid table">
      <div class="header row">
        <div class="col-xs-4">Keyword</div>
        <div class="col-xs-2">Clicks</div>
        <div class="col-xs-2">Position</div>
        <div class="col-xs-2">Google Views</div>
        <div class="col-xs-2">Click Rate</div>
      </div>
      <div class="row" *ngFor="let keywordMetric of dashboardService.website.targetedLocalLastMonthKeywords">
        <div class="col-xs-4 bold">{{ keywordMetric.keys.join(', ') }}</div>
        <div class="col-xs-2">{{ keywordMetric.clicks }}</div>
        <div class="col-xs-2">{{ keywordMetric.position.toFixed(1) }}</div>
        <div class="col-xs-2">{{ keywordMetric.impressions }}</div>
        <div class="col-xs-2">{{ (keywordMetric.ctr * 100).toFixed(1) + '%' }}</div>
      </div>
    </div>
  </fieldset>
  <fieldset>
    <legend>
      Google Keywords ~ Top 10 ~ Last Month
    </legend>
    <div class="container-fluid table">
      <div class="header row">
        <div class="col-xs-4">Keyword</div>
        <div class="col-xs-2">Clicks</div>
        <div class="col-xs-2">Position</div>
        <div class="col-xs-2">Google Views</div>
        <div class="col-xs-2">Click Rate</div>
      </div>
      <div class="row" *ngFor="let keywordMetric of dashboardService.website.topTenLastMonthKeywords">
        <div class="col-xs-4 bold">{{ keywordMetric.keys.join(', ') }}</div>
        <div class="col-xs-2">{{ keywordMetric.clicks }}</div>
        <div class="col-xs-2">{{ keywordMetric.position.toFixed(1) }}</div>
        <div class="col-xs-2">{{ keywordMetric.impressions }}</div>
        <div class="col-xs-2">{{ (keywordMetric.ctr * 100).toFixed(1) + '%' }}</div>
      </div>
    </div>
  </fieldset>
</div>
